class SubscriptionsManager {
	constructor(store, router) {
		this.store = store;
		this.router = router;
	}

	get logoutRoutes() {
		return [
			'contracting-base',
			'contracting-insured',
			'contracting-financing',
			'contracting-summary',
			'contracting-statement',
		];
	}

	async resolve(mutation, state) {
		switch (mutation.type) {
			case 'auth/setCurrentUser':
				if (
					this.logoutRoutes.includes(this.router.currentRoute.name) &&
					!this.store.getters['auth/isLoggedIn']
				) {
					this.store.commit('popupHasClose', false);
					this.store.commit('showPopup', 'ContractingLogin');
				}

				if(['comparison'].includes(this.router.currentRoute.name)&&
				!this.store.getters['auth/isLoggedIn']) {
					this.router.push({ name: 'home' });
				}
				break;
		}
	}

	isPath(path) {
		return this.router.currentRoute.fullPath === path;
	}
}

export default SubscriptionsManager;
